export default "__VITE_ASSET__DJVn9HgZ__"